import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ExclamationMarkIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M8.67 3c.403 0 .724.312.704.683l-.42 5.2c-.019.346-.328.617-.704.617h-.5c-.376 0-.685-.271-.704-.617l-.42-5.2c-.02-.371.3-.683.704-.683zM9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
			></path>
		</svg>
	),
)
